import request from '@/util/request'

export function blockDetail(param) {
  return request({
    url: '/block/getBlock',
    method: 'get',
    params: param
  })
}